// extracted by mini-css-extract-plugin
module.exports = {"red":"_1NWaA-","action":"_2ludl-"};